Ext.define('SA.AjaxError', {
    statics: {
        get({exception, message, data}) {
            var type = exception.split('\\').pop();

            if (message === 'Timeout requesting data.') {
                return this.getTimeoutError();
            }

            return new SA.AjaxError({type, message, data});
        },

        getFetchError(error) {
            return error.name === 'AbortError' ? this.getTimeoutError() : this.getNetworkError();
        },

        getJsonParseError({cause}) {
            return new SA.AjaxError({type: 'JsonParse', cause});
        },

        getNetworkError() {
            return new SA.AjaxError({type: 'Network', message: 'Error contacting server.'});
        },

        getStatusNotOkError() {
            return new SA.AjaxError({type: 'StatusNotOk'});
        },

        getTimeoutError() {
            return new SA.AjaxError({type: 'Timeout', message: 'Contacting the server took longer than expected. The request has been aborted.'});
        },

        hasInstance(error) {
            return error instanceof SA.AjaxError;
        }
    },

    constructor({type, message = 'An unexpected error occurred.', data = null, cause = null}) {
        this.type = type;
        this.message = message;
        this.data = data;
        this.cause = cause;
    },

    flagUnexpected() {
        SA.AppController.onUnexpectedAjaxError(this);
    },

    getCause() {
        return this.cause;
    },

    getData() {
        return this.data;
    },

    getMessage() {
        return this.message;
    },

    getType() {
        return this.type;
    },

    hasType(type) {
        return Ext.Array.from(type).includes(this.getType());
    },

    isSessionDirtyError() {
        return this.hasType('DirtySessionException');
    },

    isSessionError() {
        return this.isSessionExpiredError() || this.isSessionDirtyError();
    },

    isSessionExpiredError() {
        return this.hasType('UnauthorizedException');
    },

    isTimeoutError() {
        return this.hasType('Timeout');
    }
});
